import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import CustomButton from "common/components/Button/Button"
import CustomConfirmDialog from "common/components/ConfirmDialog"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { INITIAL_QUERY_PARAMETERS } from "features/Crear/components/LibradoCard/constants"
import { getListadoDepartamentos } from "features/User/pages/RoleManagement/services/roles"
import { getDepartamentos } from "features/User/redux/selectors/userSelectors"
import { setDepartamentos } from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  DEFAULT_AUTOVALIDACION,
  DOC_TYPES_KEYS,
  DOC_TYPES_OPTIONS,
  RANGE_OPTIONS,
  RANGE_SYMBOLS,
  mapDepartamentosSelectToEtapas,
  mapDepartamentosToSelect,
} from "../../constants"
import EtapasList from "../EtapasList"

import "../styles.scss"

const ApprovalsForm = ({
  hideModal,
  handleChange,
  setFieldValue,
  values,
  handleSubmit,
  errors,
  resetForm,
  isEditModal,
  handleBlur,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [localValue, setLocalValue] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [etapasSelected, setEtapasSelected] = useState(values.etapas || [])
  const [hasValorSuperior, setHasValorSuperior] = useState()
  const { departamentos, departamentosTotalCount } =
    useSelector(getDepartamentos)

  useEffect(() => {
    getListadoDepartamentos(INITIAL_QUERY_PARAMETERS).then((res) => {
      dispatch(setDepartamentos(res?.data))
    })
    return () => {
      resetForm()
      setEtapasSelected([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par...
    values.autovalidacion && setLocalValue(DEFAULT_AUTOVALIDACION.value)
    values.etapas.length && setEtapasSelected(values.etapas)
    values.rango.valorSuperior &&
      // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
      setHasValorSuperior(Boolean(values.rango.valorSuperior))
    return () => {
      setLocalValue("")
      // @ts-expect-error TS(2345): Argument of type 'false' is not assignable to para...
      setHasValorSuperior(false)
    }
  }, [values.autovalidacion, values.etapas, values.rango.valorSuperior])

  const onHandleScroll = (queryParams: $TSMigrationFixMe) => {
    getListadoDepartamentos(queryParams).then((res) => {
      dispatch(setDepartamentos(res?.data))
    })
  }

  const departamentosList = mapDepartamentosToSelect(departamentos)
  const handleSelectChange = (e: $TSMigrationFixMe, key: $TSMigrationFixMe) => {
    setFieldValue(e.value, key)
  }
  const handleEtapasSelected = useCallback(
    (e: $TSMigrationFixMe) => {
      if (e.value !== 9999) {
        const selected = departamentosList.filter(
          (departamento: $TSMigrationFixMe) => departamento.value === e.value
        )[0]
        const etapasCopy = etapasSelected.slice()
        if (etapasCopy.length === 0) {
          const etapaArray = [
            {
              ...selected,
              orden: 1,
              numeroFirmas: 1,
              departamentoNombre: selected.label,
              departamentoId: selected.value,
            },
          ]
          setEtapasSelected(etapaArray)
          setFieldValue("etapas", mapDepartamentosSelectToEtapas(etapaArray))
          setFieldValue("autovalidacion", false)
        } else if (
          etapasCopy.some(
            (el: $TSMigrationFixMe) => el.departamentoId === e.value
          )
        ) {
          setEtapasSelected(etapasCopy)
          setFieldValue("etapas", mapDepartamentosSelectToEtapas(etapasCopy))
          setFieldValue("autovalidacion", false)
        } else {
          const etapaArray = [
            ...etapasSelected,
            {
              ...selected,
              orden: etapasSelected.length + 1,
              numeroFirmas: 1,
              departamentoNombre: selected.label,
              departamentoId: selected.value,
            },
          ]

          setEtapasSelected(etapaArray)
          setFieldValue("etapas", mapDepartamentosSelectToEtapas(etapaArray))
          setFieldValue("autovalidacion", false)
        }
      } else {
        setFieldValue("autovalidacion", true)
        setFieldValue("etapas", [])
        setEtapasSelected([])
      }
    },
    [departamentosList, etapasSelected, setFieldValue]
  )
  const handleRemove = (id: $TSMigrationFixMe) => {
    const etapasCopy = etapasSelected.slice()
    if (etapasCopy.some((el: $TSMigrationFixMe) => el.departamentoId === id)) {
      const index = etapasSelected.findIndex(
        (el: $TSMigrationFixMe) => el.departamentoId === id
      )
      etapasCopy.splice(index, 1)
      setEtapasSelected(etapasCopy)
      setFieldValue("etapas", mapDepartamentosSelectToEtapas(etapasCopy))
    }
  }

  const handleCount = (
    id: $TSMigrationFixMe,
    countValue: $TSMigrationFixMe
  ) => {
    const etapasCopy = etapasSelected.slice()
    const modifiedEtapas = etapasCopy.map((etapa: $TSMigrationFixMe) => {
      if (
        (etapa.departamentoId === id && etapa.numeroFirmas > 1) ||
        (etapa.departamentoId === id &&
          etapa.numeroFirmas === 1 &&
          countValue !== -1)
      ) {
        return { ...etapa, numeroFirmas: etapa.numeroFirmas + countValue }
      }

      return etapa
    })
    setEtapasSelected(modifiedEtapas)
    setFieldValue("etapas", mapDepartamentosSelectToEtapas(modifiedEtapas))
  }

  const handleRangeChange = (e: $TSMigrationFixMe) => {
    if (e.value === 999) {
      setFieldValue("rango.operador", e.value)
      setFieldValue("todosLosRangos", true)
      setFieldValue("rango.valorInferior", "")
      setFieldValue("rango.valorSuperior", "")
      // @ts-expect-error TS(2345): Argument of type 'false' is not assignable to para...
      setHasValorSuperior(false)
    } else if (e.value === 5) {
      setFieldValue("rango.operador", e.value)
      setFieldValue("todosLosRangos", false)
      // @ts-expect-error TS(2345): Argument of type 'true' is not assignable to param...
      setHasValorSuperior(true)
    } else {
      setFieldValue("rango.operador", e.value)
      setFieldValue("todosLosRangos", false)
      // @ts-expect-error TS(2345): Argument of type 'false' is not assignable to para...
      setHasValorSuperior(false)
    }
  }

  const handleModalAutovalidacion = () => {
    setShowModal(!showModal)
  }
  const onSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    e.stopPropagation()
    if (values.autovalidacion) {
      setShowModal(!showModal)
    } else {
      handleSubmit()
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <div className='mb-3 p-fluid'>
        <label htmlFor='tipoDocumento'>
          {t("flujoAprobaciones.modalFlujo.labelTypeDocument")}
        </label>
        <Dropdown
          placeholder={`${t(
            "flujoAprobaciones.modalFlujo.placeholderTypeDocument"
          )}`}
          options={DOC_TYPES_OPTIONS(t)}
          className='rounded-none w-100'
          name='tipoDocumento'
          id='tipoDocumento'
          value={values.tipoDocumento}
          onChange={handleChange}
          panelClassName='!tw-z-[2302]'
        />
      </div>

      <div className='mb-3 select-main_content'>
        <div className='select_container '>
          <label htmlFor='tipoDocumento'>
            {t("flujoAprobaciones.modalFlujo.labelRange")}
          </label>
          <FormikDropdown
            placeholder={`${t(
              "flujoAprobaciones.modalFlujo.placeholderRange"
            )}`}
            options={RANGE_OPTIONS(t)}
            className='rounded-none w-100'
            name='rango.operador'
            id='rango.operador'
            value={values.rango.operador}
            onChange={handleRangeChange}
            errors={errors}
            onBlur={handleBlur}
            panelClassName='!tw-z-[2302]'
          />
        </div>
        <div className='text-left col-md-12 col-lg-5 select_container'>
          <label htmlFor='valorInferior'>
            {t("flujoAprobaciones.modalFlujo.labelValue")}
          </label>
          <FormikInputText
            id='rango.valorInferior'
            name='rango.valorInferior'
            onChange={handleChange}
            type='number'
            disabled={values.todosLosRangos}
            value={values.todosLosRangos ? "" : values.rango.valorInferior}
            onBlur={handleBlur}
          />
          {hasValorSuperior && (
            <>
              <label htmlFor='valorInferior'>
                {t("flujoAprobaciones.modalFlujo.labelValue")}
              </label>
              <FormikInputText
                id='rango.valorSuperior'
                name='rango.valorSuperior'
                onChange={handleChange}
                type='number'
                disabled={values.todosLosRangos}
                value={values.rango.valorSuperior}
                onBlur={handleBlur}
              />
            </>
          )}
        </div>
      </div>
      <EtapasList
        setLocalValue={setLocalValue}
        handleSelectChange={handleSelectChange}
        departamentosList={departamentosList || []}
        onHandleScroll={onHandleScroll}
        departamentosTotalCount={departamentosTotalCount}
        localValue={localValue}
        etapasSelected={values.etapas || etapasSelected}
        handleEtapasSelected={handleEtapasSelected}
        handleRemove={handleRemove}
        handleCount={handleCount}
        handleBlur={handleBlur}
        setEtapasSelected={setEtapasSelected}
        setFieldValue={setFieldValue}
      />
      <div className='departaments-modal__actions'>
        <p
          className='mr-3 link-cancel'
          onClick={() => hideModal()}
        >
          {t("flujoAprobaciones.modalFlujo.cancelButton")}
        </p>
        <CustomButton
          type='submit'
          className='tw-ml-2 !tw-bg-primary tw-cursor-pointer'
          disabled={Boolean(Object.keys(errors).length)}
        >
          {isEditModal
            ? `${t("flujoAprobaciones.modalFlujo.editFlow")}`
            : `${t("flujoAprobaciones.modalFlujo.crearFlow")}`}
        </CustomButton>
      </div>
      <CustomConfirmDialog
        visible={showModal}
        onHide={handleModalAutovalidacion}
        closable={false}
        message={
          <div className='autovalidation-modal_container'>
            <div className='autovalidation-rounded_container'>
              <div className='autovalidation-rounded-inner'>
                <FontAwesomeIcon icon={["fal", "triangle-exclamation"]} />
              </div>
            </div>
            <h6>{t("flujoAprobaciones.confirmFlow")}</h6>
            <span className='autovalidation-text_container'>
              <>
                {`${values.tipoDocumento === 2 ? "Todas" : "Todos"} tus`}
                <span className='autovalidation-text_highlighted'>
                  {" "}
                  {/* @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... */}
                  {`${DOC_TYPES_KEYS(t)[values.tipoDocumento]?.plural}`}{" "}
                </span>
                de
                <span className='autovalidation-text_highlighted'>
                  {` ${
                    values?.rango.operador !== 999
                      ? // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
                        `${RANGE_SYMBOLS(t)[values?.rango.operador]?.symbol} ${
                          values?.rango.operador === 5
                            ? `${values.rango.valorInferior} y ${values.rango.valorSuperior}`
                            : values.rango.valorInferior
                        }`
                      : ""
                  } `}
                </span>
                {`serán ${
                  values.tipoDocumento === 2 ? "validadas" : "validados"
                } automáticamente.`}
              </>
            </span>
          </div>
        }
        acceptLabel='Confirmar'
        rejectLabel='Cancelar'
        style={{ minWidth: "320px", width: "320px" }}
        accept={handleSubmit}
        className='autovalidation-modal'
        id='validation-modal'
      />
    </form>
  )
}

export default ApprovalsForm
